<div class="user-filter border-r-16" *transloco="let t">
  <div class="left-section">
    <p class="mb-0">
      <span>{{ t('user/workplace') }} </span>{{ loggedKindergarten?.name }}
    </p>
  </div>

  <button class="btn btn-primary btn-icon" [routerLink]="links.addUser()">
    <i class="material-symbols-rounded">add_2</i>{{ t('user/add') }}
  </button>
</div>
